(function (angular, undefined) {
    'use strict';

    angular.module('blocks.i18n', ['pascalprecht.translate', 'angularMoment', 'blocks.lodash', 'blocks.i18n.globalization']);
})(angular);
